module.exports = __webpack_public_path__ + "static/img/n_1_4.8eb0f23d.png";